import React, { useState } from "react";
import { useFormikContext } from "formik";
import RecipientField from "./RecipientField";
import startCase from "lodash/startCase";
import get from "lodash/get";
import { getFieldPath } from "utils/form";

const Recipients = ({ name }) => {
  const [focus, setFocus] = useState("signers[0]");
  const { values } = useFormikContext();

  const recipients = get(values, name);

  let recipientGroups = [];
  if (recipients) {
    Object.keys(recipients).forEach((key, keyIx) => {
      recipients[key] && recipients[key].length > 0
        ? recipientGroups.push(
            <div key={key} className={`w-100 ${keyIx ? "pt3" : ""}`}>
              <div className="fw6 f6">{startCase(key)}</div>
              <ul className="list ma0 pa0 pt2">
                {recipients[key].map((_, recipientIx) => {
                  const fieldKey = `${key}[${recipientIx}]`;

                  const fieldName = getFieldPath(name, fieldKey);
                  return (
                    <li
                      className={`w-100 ${recipientIx ? "pt3" : ""}`}
                      key={fieldKey}
                    >
                      <RecipientField
                        name={fieldName}
                        focusKey={fieldKey}
                        focus={focus}
                        setFocus={setFocus}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          )
        : null;
    });
  }

  return (
    <div className="w-100">
      <div className="f5 fw6 pb2">Recipients</div>
      {recipientGroups}
    </div>
  );
};

export default Recipients;
